import Pricing from "../store/Pricing";
import isPayplusDomain from "./isPayplusDomain";

// Цена для кнопки "Купить игру" по текущему домену (ТЗ Этап 2 #4: 49$ / 4900 ₽).
// .ru → рубли, .com / in-touch.space / dev / localhost → доллары.
// Значение из серверного справочника (Pricing.fetch делает App.js на старте;
// здесь только чтение — никаких запросов из render), фолбэк — ценник Этапа 2.
export default function getDomainPrice() {
  const price = Pricing.get("GAME");
  if (!isPayplusDomain()) {
    const rub = price?.rub ?? 4900;
    return `${String(rub).replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ₽`;
  }
  const usd = price?.usd ?? 49;
  return `${usd}$`;
}
